/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sharewithmicrosoft2Inputs */



/**

* @param {_Field_Sharewithmicrosoft2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_sharewithmicrosoft2 = /** @type {((inputs?: _Field_Sharewithmicrosoft2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sharewithmicrosoft2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Persönliche Daten mit Microsoft teilen")
});
export { _field_sharewithmicrosoft2 as "_field_shareWithMicrosoft" }